export default __webpack_public_path__ + "static/media/religion.187e6604.png";